import { StaticPricingTab } from './pricing-display-static.types';

export const STATIC_PRICING_MISC_TABS: StaticPricingTab[] = [
  {
    id: 'accuzip6-full-service-limited',
    label: 'AccuZIP6 Full-Service Limited',
    tabNotes: [
      {
        type: 'heading',
        text: 'AccuZIP6 Full-Service Limited Edition Desktop Transaction Pricing',
      },
    ],
    sections: [
      {
        title: 'Desktop Transaction Pricing',
        headers: [
          'Job Transaction Size',
          'First Time Use Price',
          'Multiple Use 60.00%',
        ],
        rows: [
          ['1 - 1,000', '$16', '$6'],
          ['1,001 - 2,000', '$24', '$10'],
          ['2,001 - 5,000', '$32', '$13'],
          ['5,001 - 10,000', '$44', '$18'],
          ['10,001 - 20,000', '$64', '$26'],
          ['20,001 - 50,000', '$108', '$43'],
        ],
      },
      {
        title: 'AccuZIP6 Full-Service Limited Edition Subscription Pricing',
        headers: [
          'Total Monthly Jobs',
          'Paid Monthly',
          'If Paid Monthly*',
          'Paid Annually',
          'Two Year',
          'Three Year',
          'Four Year',
          'Five Year',
        ],
        rows: [
          ['5', '$29', '$348', '$313', '$592', '$835', '$1,044', '$1,218'],
          ['10', '$49', '$588', '$529', '$1,000', '$1,411', '$1,764', '$2,058'],
          [
            '25',
            '$99',
            '$1,188',
            '$1,069',
            '$2,020',
            '$2,851',
            '$3,564',
            '$4,158',
          ],
          [
            '50',
            '$189',
            '$2,268',
            '$2,041',
            '$3,856',
            '$5,443',
            '$6,804',
            '$7,938',
          ],
        ],
        notes: [
          { type: 'paragraph', text: '* Limit 50,000 records per database' },
        ],
      },
    ],
  },
  {
    id: 'variable-maps',
    label: 'Variable Maps',
    tabNotes: [{ type: 'heading', text: 'Variable/Personalized Maps' }],
    sections: [
      {
        headers: [],
        rows: [],
        notes: [
          { type: 'heading', text: 'Notes:' },
          {
            type: 'paragraph',
            text: 'We can create these maps now for any mailing list and up to 5-destinations. If they have more than 5-destinations, please get more information about their needs and Steve will assist in quoting.',
          },
          {
            type: 'paragraph',
            text: 'Customer needs to provide their Mailing List to us along with the Destination Addresses and each map would represent the closest driving direction from each mailing address to one of five destinations.',
          },
        ],
      },
      {
        headers: [
          'Maps',
          'Map Price',
          'Total Price',
          'Google Map Cost',
          'Google Map Total Price',
          'Profit %',
        ],
        rows: [
          ['1,000', '$0.2470', '$247', '$0.005', '$5.00', '202.43%'],
          ['2,000', '$0.2340', '$468', '$0.005', '$10.00', '213.68%'],
          ['3,000', '$0.2210', '$663', '$0.005', '$15.00', '226.24%'],
          ['4,000', '$0.2080', '$832', '$0.005', '$20.00', '240.38%'],
          ['5,000', '$0.1820', '$910', '$0.005', '$25.00', '274.73%'],
          ['6,000', '$0.1690', '$1,014', '$0.005', '$30.00', '295.86%'],
          ['7,000', '$0.1560', '$1,092', '$0.005', '$35.00', '320.51%'],
          ['8,000', '$0.1430', '$1,144', '$0.005', '$40.00', '349.65%'],
          ['9,000', '$0.1300', '$1,170', '$0.005', '$45.00', '384.62%'],
          ['10,000', '$0.1235', '$1,235', '$0.005', '$50.00', '404.86%'],
          ['20,000', '$0.0949', '$1,898', '$0.005', '$100.00', '526.87%'],
          ['30,000', '$0.0858', '$2,574', '$0.005', '$150.00', '582.75%'],
          ['40,000', '$0.0806', '$3,224', '$0.005', '$200.00', '620.35%'],
          ['50,000', '$0.0780', '$3,900', '$0.005', '$250.00', '641.03%'],
          ['60,000', '$0.0741', '$4,446', '$0.005', '$300.00', '674.76%'],
          ['70,000', '$0.0702', '$4,914', '$0.005', '$350.00', '712.25%'],
          ['80,000', '$0.0689', '$5,512', '$0.005', '$400.00', '725.69%'],
          ['90,000', '$0.0663', '$5,967', '$0.005', '$450.00', '754.15%'],
          ['100,000', '$0.0650', '$6,500', '$0.005', '$500.00', '769.23%'],
          ['200,000', '$0.0572', '$11,440', '$0.005', '$1,000.00', '874.13%'],
          ['300,000', '$0.0546', '$16,380', '$0.005', '$1,500.00', '915.75%'],
          ['400,000', '$0.0507', '$20,280', '$0.005', '$2,000.00', '986.19%'],
        ],
      },
    ],
  },
  {
    id: 'list-pricing',
    label: 'List Pricing',
    sections: [
      {
        title: 'Pricing:*',
        headers: ['Description'],
        rows: [
          [
            'One-time use: $0.03 each record, regardless of list size, no minimum',
          ],
          [
            'Multiple use: $0.045 each record, regardless of list size, no minimum',
          ],
        ],
      },
      {
        title: 'Available Lists:',
        headers: ['List Type'],
        rows: [
          ['Business - 16 Million Businesses'],
          ['New Business - 25k New Businesses Updated Weekly'],
          ['Consumer - 200 Million+'],
          ['New Homeowner - 100 Million+ New Homeowners'],
          ['New Mover - 200k+ New Movers Each Week'],
        ],
      },
      {
        title:
          'Data Quality Price (CASS, NCOALink, Duplicate Detection, Presort)',
        headers: ['From', 'To', 'Price'],
        rows: [
          ['1', '199', 'Free'],
          ['200', '1,000', '$3.00'],
          ['1,001', '2,000', '$4.00'],
          ['2,001', '5,000', '$5.00'],
          ['5,001', '10,000', '$7.00'],
          ['10,001', '20,000', '$10.00'],
          ['20,001', '50,000', '$17.00'],
          ['50,001', '100,000', '$30.00'],
          ['100,001', '500,000', '$55.00'],
          ['500,001', '1,000,000', '$55.00'],
          ['1,000,001', '1,500,000', '$90.00'],
          ['1,501,000', '2,000,000', '$90.00'],
          ['2,000,001', '2,500,000', '$120.00'],
        ],
        notes: [
          { type: 'paragraph', text: '*Additional Fee' },
          {
            type: 'paragraph',
            text: 'The fee is 0.03 per Address purchased (regardless of the list type and no minimums), which is the lowest in the industry, and for a small required additional fee, (fees listed) below we do the DQ as part of the process',
          },
          {
            type: 'paragraph',
            text: 'The service of real-time CASS, NCOALink, Duplicate Detection and Presort is a value add and we do charge separately for it. You cannot NOT purchase lists in the AccuZIP DQ API without CASS so the above fees are added by default to any List Purchase',
          },
        ],
      },
    ],
  },
  {
    id: 'konica',
    label: 'Konica',
    sections: [],
    tabNotes: [
      {
        type: 'paragraph',
        text: '1. The AccuZIP Sales person helps the Konica representative with his/her solution (product features, applications, benefits). WE DO NOT provide pricing to the Konica representative. If they ask, we will respond with "I will get that to you".',
      },
      {
        type: 'paragraph',
        text: '2. Contact Bob Babb (do not copy the Konica representative) via email and let him know what they want.',
      },
      {
        type: 'paragraph',
        text: '3. Bob will generate pricing and execute the order or PO which we will provide to Sandy.',
      },
      {
        type: 'paragraph',
        text: 'Re: Upgrades, Renewals, Add-Ons - Eric is finding out from Bob on 7/5/2018',
      },
      {
        type: 'paragraph',
        text: 'Bob Babb [mailto:rbabb@kmbs.konicaminolta.us]',
      },
    ],
  },
  {
    id: 'living-mail',
    label: 'Living Mail',
    tabNotes: [
      { type: 'heading', text: 'LIVINGMAIL transactional fees:' },
      { type: 'list-item', text: '2₵ per outgoing SMS' },
      { type: 'list-item', text: '2₵ per incoming SMS' },
      { type: 'list-item', text: '4₵ per minute outbound calls' },
      { type: 'list-item', text: '2₵ per minute recorded calls' },
      {
        type: 'list-item',
        text: 'Tiered pricing for outgoing email (using White Listed Email Servers)',
      },
    ],
    sections: [
      {
        title: 'Email Triggers Tiered Pricing',
        headers: ['Tier', '_ftn1', 'Email Service', 'SMS', 'Voice', ''],
        rows: [
          ['A', 'Up to 500', '$0.05', 'N/A', 'N/A', ''],
          ['B', '501 - 1,000', '$0.05', 'N/A', 'N/A', ''],
          ['C', '1001 - 2,000', '$0.04', 'N/A', 'N/A', ''],
          ['D', '2001 - 3,000', '$0.04', 'N/A', 'N/A', ''],
          ['E', '3001 - 4,000', '$0.03', 'N/A', 'N/A', ''],
          ['F', '4001 - 5,000', '$0.02', 'N/A', 'N/A', ''],
          ['G', '5001 - 7,000', '$0.02', 'N/A', 'N/A', ''],
          ['H', '7001 - 10,000', '$0.01', 'N/A', 'N/A', ''],
          ['I', '10,001+', '$0.01', 'N/A', 'N/A', ''],
        ],
      },
    ],
  },
];
